import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { fetchAssistantUsage } from "../../../views/Admin/AssistantUsage/assistantUsageApi";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// The Node Mobile assistant over the last 7 days (Admin): requests, how many
// came through Siri, and the most-asked thing it couldn't do.
const AssistantUsageWidget = () => {
  const user = useSelector(selectUser);
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!user?.id) return;
    fetchAssistantUsage(user.id, 7)
      .then(setData)
      .catch(() => setFailed(true));
  }, [user?.id]);

  if (!data) {
    return (
      <WidgetFrame title="Assistant Usage" to="/admin/assistant-usage">
        <WidgetEmpty>{failed ? "Couldn't load assistant usage." : "Loading usage…"}</WidgetEmpty>
      </WidgetFrame>
    );
  }

  const { totals } = data;
  const topAsk = data.unsupported[0];

  return (
    <WidgetFrame title="Assistant Usage" to="/admin/assistant-usage">
      {totals.requests === 0 ? (
        <WidgetEmpty>No assistant requests this week.</WidgetEmpty>
      ) : (
        <>
          <div className="grid grid-cols-3 gap-2">
            <WidgetStat value={totals.requests} label="This week" />
            <WidgetStat value={totals.siri} label="Siri" />
            <WidgetStat value={totals.unsupported} label="Couldn't do" />
          </div>
          {topAsk && (
            <p className="app-muted mt-2 truncate text-xs">
              Most asked: {topAsk.request}
              {topAsk.count > 1 ? ` (${topAsk.count}×)` : ""}
            </p>
          )}
        </>
      )}
    </WidgetFrame>
  );
};

export default AssistantUsageWidget;
